// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  
.complete-header-image {
  justify-content: center;
  display: flex;
  padding: 10px;
}
.complete-header-image > img {
  width: 90px;
}
.complete-header-text {
  font-size: 20px;
  font-weight: bold;
  justify-content: center;
  display: flex;
  padding: 10px;
}
.complete-text {
  font-size: 16px;
  padding: 10px 5px;
  align-items: center;
  display: flex;
  justify-content: center;
  text-align: center;
  color: gray;
}

  `, "",{"version":3,"sources":["webpack://./src/app/services/payment.service.ts"],"names":[],"mappings":";;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;AACb","sourcesContent":["\n  \n.complete-header-image {\n  justify-content: center;\n  display: flex;\n  padding: 10px;\n}\n.complete-header-image > img {\n  width: 90px;\n}\n.complete-header-text {\n  font-size: 20px;\n  font-weight: bold;\n  justify-content: center;\n  display: flex;\n  padding: 10px;\n}\n.complete-text {\n  font-size: 16px;\n  padding: 10px 5px;\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  text-align: center;\n  color: gray;\n}\n\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
